import { useQuery } from '@tanstack/react-query'
import { useAuth0 } from '@auth0/auth0-react'
import { api } from '@/lib/api'
import { useViewAsId } from '@/lib/viewAs'

const POLL_MS = 60_000

async function countOnly(query: Record<string, unknown>): Promise<number> {
  const res = await api<{ total: number }>('/support-tickets', {
    query: { ...query, limit: 0 },
  })
  return res.total ?? 0
}

export function useTicketCounts() {
  const { user } = useAuth0()
  const isAdmin = Boolean((user as Record<string, unknown> | undefined)?.['https://app.etainabl.com/isAdmin'])
  const asUser = useViewAsId()
  const lensActive = Boolean(asUser)

  const inbox = useQuery({
    queryKey: ['ticketCounts', 'inbox', asUser ?? null],
    queryFn: () => countOnly(asUser ? { asUserId: asUser } : {}),
    refetchInterval: POLL_MS,
    // Admins have no personal inbox outside the lens — the Tickets link is
    // hidden then too (see Navbar), so there is nothing for this to feed.
    enabled: !isAdmin || lensActive,
  })

  const queue = useQuery({
    queryKey: ['ticketCounts', 'queue'],
    queryFn: () => countOnly({ status: 'open' }),
    refetchInterval: POLL_MS,
    enabled: isAdmin && !lensActive,
  })

  return {
    inbox: inbox.data ?? 0,
    queue: queue.data ?? 0,
    isAdmin,
  }
}
